/* eslint-disable prefer-const */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { MapPinElement } from './MapPinElement';
import analytics from '../../analytics/analytics';
export const createMapAdvancedMarkerElement = options => {
  const {
    gMap,
    AdvancedMarkerElement,
    pinDetails
  } = options;
  if (!pinDetails.lat || !pinDetails.lng) {
    return;
  }
  // Create the Pin
  const latLng = {
    lat: pinDetails.lat,
    lng: pinDetails.lng
  };
  const pinContainer = document.createElement('div');
  const pinReactRoot = createRoot(pinContainer);
  try {
    // AdvancedMarkerElement will add pin to the map
    // ====== IMPORTANT NOTE ======
    // MUST use "let markerDOM" instead of "const"
    // After AdvancedMarkerElement created, it will manipulate the markerDOM directly
    // const will block the manipulation
    // Which will fail the marker rendering on the map
    let markerDOM = new AdvancedMarkerElement({
      content: pinContainer,
      map: gMap,
      position: latLng,
      gmpClickable: true
    });
    // Render pin component on the map
    pinReactRoot.render(React.createElement(MapPinElement, Object.assign({}, pinDetails, {
      markerDOM: markerDOM
    })));
  } catch (e) {
    analytics.logError({
      loggedFrom: 'MapPinElement',
      message: 'MAP_EVENT_ERROR',
      errorMessage: e === null || e === void 0 ? void 0 : e.message
    });
  }
};